/* Shreya — recently viewed products (history kept in localStorage). */
(() => {
  if (customElements.get('recently-viewed')) return;

  const KEY = 'shreya:recently-viewed';
  const MAX = 20;

  const readHistory = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.map(Number).filter(Boolean) : [];
    } catch (_) {
      return [];
    }
  };
  const writeHistory = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (_) { /* storage unavailable */ }
  };

  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.section');
      this.track = this.querySelector('[data-slider-track]');
      const current = Number(this.dataset.current || 0);
      if (current) writeHistory([current, ...readHistory().filter((id) => id !== current)]);

      const clear = this.querySelector('[data-viewed-clear]');
      if (clear) clear.addEventListener('click', () => this.clear());

      let ids = readHistory();
      if (current && this.hasAttribute('data-exclude-current')) ids = ids.filter((id) => id !== current);
      ids = ids.slice(0, parseInt(this.dataset.limit || '8', 10));
      if (ids.length) this.load(ids);
    }

    async load(ids) {
      const query = ids.map((id) => `id:${id}`).join(' OR ');
      try {
        const res = await fetch(`${this.dataset.url}&q=${encodeURIComponent(query)}`);
        if (!res.ok) return;
        const doc = window.Theme.parseHTML(await res.text());
        const slides = Array.from(doc.querySelectorAll('[data-viewed-results] > li'));
        if (!slides.length) return;
        // The search returns its own order: put the most recent first again.
        slides.sort((a, b) => ids.indexOf(Number(a.dataset.productId)) - ids.indexOf(Number(b.dataset.productId)));
        this.track.replaceChildren(...slides.map((li) => document.importNode(li, true)));
        if (this.section) this.section.classList.remove('is-pending');
        window.Theme.init(this);
        // Ask the carousel to recalculate arrows/progress for the new slides.
        const carousel = this.querySelector('slider-carousel');
        if (carousel && carousel.update) requestAnimationFrame(() => carousel.update());
      } catch (_) { /* keep the section hidden */ }
    }

    clear() {
      try { localStorage.removeItem(KEY); } catch (_) { /* ignore */ }
      if (this.section && !window.Shopify?.designMode) this.section.classList.add('is-pending');
      else this.track.querySelectorAll('li:not([data-placeholder])').forEach((li) => li.remove());
    }
  }

  customElements.define('recently-viewed', RecentlyViewed);
})();
